import React from 'react';
import ReactDocumentTitle from 'react-document-title';
import PropTypes from 'prop-types';

export const DocumentTitle = ({ title, children }) => <ReactDocumentTitle title={title}>{children}</ReactDocumentTitle>;
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
DocumentTitle.displayName = 'DocumentTitle';
